import { router } from '@inertiajs/react'
import { useEffect, useState } from 'react'
import Icon from './components/Icon'

// Light/dark toggle (architecture §6.9). Flips `data-theme` on <html> instantly
// for a snappy switch, then persists the choice (cookie) so the server renders
// the same theme on the next load with no flash. Shared by both shells.
type Mode = 'light' | 'dark'

function currentMode(): Mode {
  if (typeof document === 'undefined') return 'light'
  return document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light'
}

export default function ThemeToggle() {
  const [mode, setMode] = useState<Mode>('light')

  useEffect(() => setMode(currentMode()), [])

  function toggle() {
    const next: Mode = mode === 'dark' ? 'light' : 'dark'
    document.documentElement.dataset.theme = next
    setMode(next)
    router.post('/theme', { theme: next }, { preserveScroll: true, preserveState: true })
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Toggle light/dark theme"
      aria-pressed={mode === 'dark'}
      className="grid h-9 w-9 place-items-center rounded-[10px] border border-transparent text-ink-2 hover:border-border hover:bg-surface-3 hover:text-ink"
    >
      <Icon name={mode === 'dark' ? 'sun' : 'moon'} size={18} />
    </button>
  )
}
